import ChevronLeftIcon from "./ChevronLeftIcon.mjs";

const ChevronRightIcon = class extends ChevronLeftIcon {
	render() {
		const p = structuredClone(this.props) || {};
		if ( ! p.style ) p.style = {};
		p.style.transform = "rotate(180deg)";
		return <ChevronLeftIcon {...p} />;
	}
}

export default ChevronRightIcon;